import { Language } from '../types/multilingualSettings';

/**
 * Array of available languages for the application
 */
export const AVAILABLE_LANGUAGES: Language[] = [
  {
    code: 'en',
    label: 'English',
    flag: '🇬🇧'
  },
  {
    code: 'fr',
    label: 'Français',
    flag: '🇫🇷'
  },
  {
    code: 'es',
    label: 'Español',
    flag: '🇪🇸'
  },
  {
    code: 'de',
    label: 'Deutsch',
    flag: '🇩🇪'
  },
  {
    code: 'it',
    label: 'Italiano',
    flag: '🇮🇹'
  },
  {
    code: 'pt',
    label: 'Português',
    flag: '🇵🇹'
  },
  {
    code: 'nl',
    label: 'Nederlands',
    flag: '🇳🇱'
  },
  {
    code: 'ar',
    label: 'العربية',
    flag: '🇸🇦'
  },
  {
    code: 'zh',
    label: '中文',
    flag: '🇨🇳'
  },
  {
    code: 'ru',
    label: 'Русский',
    flag: '🇷🇺'
  },
  {
    code: 'ja',
    label: '日本語',
    flag: '🇯🇵'
  },
  {
    code: 'ko',
    label: '한국어',
    flag: '🇰🇷'
  }
]; 